<template>
    <PopoverRight ref="popoverMenu" width="550px" >
        <div class="popover-slider-bar">
            <h1 class="bar-title">新增百科分类</h1>
            <el-form class="form-container" :model="catInfo" :rules="catRules" ref="catInfoForm">
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">分类名称</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item">
                        <el-form-item label="" prop="name">
                            <el-input placeholder="请输入分类名称"  v-model="catInfo.name">
                            </el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">分类层级</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item">
                        <el-form-item label="">
                            <el-select v-model="catInfo.level_id" @change="getTopLevel">
                                <el-option label="一级分类" value="1"></el-option>
                                <el-option label="二级分类" value="2"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                   
                </div>
                  <div class="form-item" v-if="showTop">
                    <div class="form-label">
                        <span class="label">上级分类</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item">
                         <el-form-item label="" prop="up_id">
                            <el-select v-model="catInfo.up_id">
                                <el-option v-for="item in topLevel" :key="item.id" :label="item.name" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </div>
                  <div class="form-item">
                    <div class="form-label">
                        <span class="label">排序</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item">
                        <el-form-item label="" prop="sort">
                            <el-input type="number"   v-model="catInfo.sort">
                            </el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-button">
                    <el-button type="primary" @click="submitForm('catInfoForm')">确 认</el-button>
                    <el-button type="info" plain @click.stop.prevent="hide">取 消</el-button>
                </div>
            </el-form>
        </div>
    </PopoverRight>
</template>

<script>
    import { categoriesLevelOne,addCategorie } from '@/service/wikipedia'
    import PopoverRight from '@/components/popoverRight/index'
    export default {
        name: "baikeAdd",
        components: {
            PopoverRight
        },
        props: {
            callback: Function
        },
        
        data () {
            const validateSort = (rule, value, callback) => {
               if (/^-?\d+$/.test(value) === false || value > 9999 || value < -9999 || value === '-0') {
                    callback(new Error(`请输入-9999-9999之间的排序数字`))
                }else {
                    callback()
                }
            }
            return {
                showTop:false,
                catInfo: {
                    name: '',
                    up_id:'',
                    level_id:'1',
                    sort: '0',
                },
                topLevel : [], //一级分类

                catRules: {
                    name: [
                        { required: true, message: '请填写名称', trigger: 'blur' },
                        { min: 1, max: 6, message: '长度在 1 到 6 个字符', trigger: 'blur' }
                    ],
                    up_id:[{ required: true, message: "请选择上级分类", trigger: "change" }],
                    sort: [
                      {validator: validateSort,trigger: "blur"}
                    ],
                },
            }
        },
        mounted(){
            
        },
        methods : {
            open () {
                this.getCatOne()
                this.$refs.popoverMenu && this.$refs.popoverMenu.open()
            },
            /** 关闭右侧悬浮层 */
            hide () {
                this.resetForm();
                this.$refs.popoverMenu && this.$refs.popoverMenu.hide()
                this.$refs.catInfoForm && this.$refs.catInfoForm.clearValidate()
            },
            resetForm () {
                this.catInfo = {
                    name: '',
                    up_id:'',
                    level_id:'1',
                    sort: '0'
                }
                this.showTop=false
            },
            getCatOne(){
                  categoriesLevelOne({}).then(data => {
                    this.topLevel = data;
                });
            },
            getTopLevel(val){ //查询一级分类
                if(val==2){
                    this.showTop=true
                }else{
                    this.showTop=false
                }
               
            },
            submitForm (formName) {
                this.$refs[formName].validate(async (valid) => {
                    if (valid) {

                      addCategorie(this.catInfo).then((data) => {
                            this.$message({
                                message: '添加成功',
                                type: 'success',
                                duration: 3 * 1000
                            })
                            this.resetForm()
                            this.hide()
                            this.callback && this.callback()
                        }).catch(err => {
                            const message = err.message
                            this.$message({
                                message: message || '添加失败',
                                type: 'error',
                                duration: 3 * 1000
                            })
                        })  

                    } else {
                        return false
                    }
                })
            },
        },
    }
</script>

<style scoped>

</style>
